module.exports = __webpack_public_path__ + "img/program-icon-active.3116246f.svg";